import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Constant} from '../../../../global/util/Constant';
import {Person} from '../../../model/Person';
import {OperationType} from '../../../../global/util/OperationType';

@Component({
  selector: 'app-view-participant',
  templateUrl: './view-participant.component.html',
  styleUrls: ['./view-participant.component.css']
})
export class ViewParticipantComponent implements OnInit {

  public peopleReceived: Person[];

  constructor(private activeModal: NgbActiveModal) {
  }

  ngOnInit() {
  }

  accept() {
    this.activeModal.close(ViewParticipantComponent);
  }

  public getOperationDescription(person: any): string {
    if (person._more) {
      return person._more.operationDescription;
    }
  }

  public getCurrentOperation(person: any): string {
    if (person._more) {
      return OperationType.SIGN === person._more.operationId ? ('LABEL.SIGNING') : ('LABEL.REVISING');
    }
  }

  public isSigner(person: any) {
    if (person._more) {
      return Constant.SIGN_OPTION === person._more.operationId;
    }
  }

  public isOperationComplete(person: any) {
    return Constant.COMPLETED === person._more.operationCompleted;
  }

  public isEnabledBySignature(person: any) {
    return person._more.enabled;
  }
}
